import React from "react";
import OpenPDFButton from "./OpenPDFButton";
import companyInfo from "../data/companyInfo";
import adtLogo from "../assets/img/portfolio/adt-security-services-logo.jpg";
import cgiLogo from "../assets/img/portfolio/cgi-federal.jpg";
import judgeLogo from "../assets/img/portfolio/judge.jpg";
import dodSeal from "../assets/img/gov/dod-seal.png";
import navySeal from "../assets/img/gov/navy-seal.png";

const clientLogos = {
  "ADT Inc": adtLogo,
  "CGI Inc": cgiLogo,
  "The Judge Group": judgeLogo,
};

function FedSupplier() {
  const {
    federal,
    coreCompetencies,
    differentiators,
    contact,
    clients,
    pastPerformance,
  } = companyInfo;

  return (
    <section className="bizmak-section fedsupplier" id="fedsupplier">
      <div className="container">
        <h2 className="page-section-heading text-center text-blue mb-0">
          Government contracting
        </h2>
        <p className="section-intro">
          BizMak Inc is a SAM.gov-registered federal supplier with an active
          Department of Defense contract supporting the U.S. Department of the
          Navy — backed by a Fortune 500 commercial track record.
        </p>
        <div className="divider-custom">
          <div className="divider-custom-line" />
          <div className="divider-custom-icon">
            <i className="fas fa-star" aria-hidden="true" />
          </div>
          <div className="divider-custom-line" />
        </div>

        {/* Federal past performance — the first thing a CO should see */}
        <div className="bizmak-past-performance">
          {pastPerformance.map((p) => (
            <div key={p.agency} className="bizmak-pp-card">
              <div className="bizmak-pp-seals" aria-hidden="true">
                <img src={dodSeal} alt="" loading="lazy" />
                <img src={navySeal} alt="" loading="lazy" />
              </div>
              <div className="bizmak-pp-body">
                <span className="bizmak-pp-status">{p.status}</span>
                <h3>
                  {p.agency}
                  <span className="bizmak-pp-parent"> · {p.parent}</span>
                </h3>
                <p>{p.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="row g-4">
          {/* Company data */}
          <div className="col-lg-5">
            <div className="bizmak-feature flex-column h-100">
              <h3 className="bizmak-gov-heading">
                <i className="fas fa-landmark me-2" aria-hidden="true" />
                Company data
              </h3>
              <table className="bizmak-gov-table" aria-label="Federal registration data">
                <tbody>
                  <tr>
                    <th scope="row">Unique Entity ID</th>
                    <td>{federal.uei}</td>
                  </tr>
                  <tr>
                    <th scope="row">CAGE Code</th>
                    <td>{federal.cageCode}</td>
                  </tr>
                  <tr>
                    <th scope="row">SAM.gov</th>
                    <td>Active registration</td>
                  </tr>
                  <tr>
                    <th scope="row">Primary NAICS</th>
                    <td>{federal.primaryNaics}</td>
                  </tr>
                  <tr>
                    <th scope="row">Point of contact</th>
                    <td>
                      {contact.name}, {contact.title}
                      <br />
                      <a href={contact.phoneHref}>{contact.phone}</a>
                      <br />
                      <a href="#contact">Contact form</a> · email on capability
                      statement
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Address</th>
                    <td>{contact.address}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* NAICS codes */}
          <div className="col-lg-7">
            <div className="bizmak-feature flex-column h-100">
              <h3 className="bizmak-gov-heading">
                <i className="fas fa-list-ol me-2" aria-hidden="true" />
                NAICS codes
              </h3>
              <table className="bizmak-gov-table" aria-label="NAICS codes">
                <tbody>
                  {federal.naicsCodes.map((n) => (
                    <tr key={n.code}>
                      <th scope="row">
                        {n.code}
                        {n.primary && (
                          <span className="bizmak-badge-primary">Primary</span>
                        )}
                      </th>
                      <td>{n.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Core competencies */}
          <div className="col-lg-6">
            <div className="bizmak-feature flex-column h-100">
              <h3 className="bizmak-gov-heading">
                <i className="fas fa-gears me-2" aria-hidden="true" />
                Core competencies
              </h3>
              <ul className="bizmak-gov-list">
                {coreCompetencies.map((c) => (
                  <li key={c}>{c}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Differentiators */}
          <div className="col-lg-6">
            <div className="bizmak-feature flex-column h-100">
              <h3 className="bizmak-gov-heading">
                <i className="fas fa-trophy me-2" aria-hidden="true" />
                Why BizMak
              </h3>
              <ul className="bizmak-gov-list">
                {differentiators.map((d) => (
                  <li key={d}>{d}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Client trust strip */}
        <div className="bizmak-client-strip">
          <p className="bizmak-client-strip-label">
            Trusted by Fortune 500 companies
          </p>
          <div className="bizmak-client-logos">
            {clients.map((c) => (
              <img
                key={c.name}
                src={clientLogos[c.name]}
                alt={c.name}
                title={c.name}
                loading="lazy"
              />
            ))}
          </div>
        </div>

        <div className="text-center mt-5">
          <OpenPDFButton variant="teal-outline" />
        </div>
      </div>
    </section>
  );
}

export default FedSupplier;
